export const ntInstallsData = [
  {
    "name": "Anula",
    "value": 3,
    "lat": -12.3922305,
    "lng": 130.8915248
  },
  {
    "name": "Barracks",
    "value": 1,
    "lat": -12.43770315,
    "lng": 130.9775740908977
  },
  {
    "name": "Batchelor",
    "value": 3,
    "lat": -13.0468045,
    "lng": 131.0283583
  },
  {
    "name": "Bees Creek",
    "value": 1,
    "lat": -12.555285,
    "lng": 131.059105
  },
  {
    "name": "Bellamack",
    "value": 1,
    "lat": -12.5149787,
    "lng": 130.9830562
  },
  {
    "name": "Belyuen",
    "value": 1,
    "lat": -12.552481,
    "lng": 130.6831795
  },
  {
    "name": "Berrimah",
    "value": 18,
    "lat": -12.433883,
    "lng": 130.9229031
  },
  {
    "name": "Bess Creek",
    "value": 1,
    "lat": -19.6481652,
    "lng": 134.1899847
  },
  {
    "name": "Brennan",
    "value": 1,
    "lat": -12.456534059282712,
    "lng": 130.94532539384346
  },
  {
    "name": "Casuarina",
    "value": 4,
    "lat": -12.3737641,
    "lng": 130.8823639
  },
  {
    "name": "Coconut Grove",
    "value": 5,
    "lat": -12.3988881,
    "lng": 130.8524998
  },
  {
    "name": "Cullen Bay",
    "value": 2,
    "lat": -12.4523718,
    "lng": 130.82284326629875
  },
  {
    "name": "Darwin",
    "value": 38,
    "lat": -12.46044,
    "lng": 130.8410469
  },
  {
    "name": "Darwin Airport",
    "value": 3,
    "lat": -12.41190185,
    "lng": 130.88362011136644
  },
  {
    "name": "Darwin City",
    "value": 19,
    "lat": -12.46044,
    "lng": 130.8410469
  },
  {
    "name": "Driver",
    "value": 2,
    "lat": -12.4846409,
    "lng": 130.9737039
  },
  {
    "name": "Durack",
    "value": 2,
    "lat": -12.475085,
    "lng": 130.973005
  },
  {
    "name": "Durack Heights",
    "value": 1,
    "lat": -12.475085,
    "lng": 130.973005
  },
  {
    "name": "East Arm",
    "value": 8,
    "lat": -12.4801795,
    "lng": 130.89913551670338
  },
  {
    "name": "Eaton",
    "value": 2,
    "lat": -12.414596,
    "lng": 130.8822985
  },
  {
    "name": "Fannie Bay",
    "value": 3,
    "lat": -12.4254152,
    "lng": 130.83650710498836
  },
  {
    "name": "Gray",
    "value": 2,
    "lat": -12.4918456,
    "lng": 130.9791964
  },
  {
    "name": "Hidden Valley",
    "value": 1,
    "lat": -12.447854,
    "lng": 130.90615850006722
  },
  {
    "name": "Holtze",
    "value": 4,
    "lat": -12.461,
    "lng": 130.984
  },
  {
    "name": "Howard Springs",
    "value": 4,
    "lat": -12.4969791,
    "lng": 131.0470011
  },
  {
    "name": "Humpty Doo",
    "value": 4,
    "lat": -12.5743657,
    "lng": 131.1018215
  },
  {
    "name": "Jingil",
    "value": 1,
    "lat": -12.3882883,
    "lng": 130.8748581
  },
  {
    "name": "Jingili",
    "value": 2,
    "lat": -12.3882883,
    "lng": 130.8748581
  },
  {
    "name": "Johnston",
    "value": 2,
    "lat": -12.4908002,
    "lng": 131.0064697
  },
  {
    "name": "Karama",
    "value": 1,
    "lat": -12.3991045,
    "lng": 130.9155177
  },
  {
    "name": "Katherine",
    "value": 4,
    "lat": -14.4646157,
    "lng": 132.2635993
  },
  {
    "name": "Knuckey Lagoon",
    "value": 2,
    "lat": -12.4268573,
    "lng": 130.9393361
  },
  {
    "name": "Larrakeyah",
    "value": 11,
    "lat": -12.4585069,
    "lng": 130.8216982
  },
  {
    "name": "Leanyer",
    "value": 1,
    "lat": -12.3743634,
    "lng": 130.8980162
  },
  {
    "name": "Lee Point",
    "value": 5,
    "lat": -12.3386479,
    "lng": 130.893592
  },
  {
    "name": "Ludmilla",
    "value": 5,
    "lat": -12.4254275,
    "lng": 130.851061
  },
  {
    "name": "Malak",
    "value": 2,
    "lat": -12.3935613,
    "lng": 130.9024071
  },
  {
    "name": "Marlows Lagoon",
    "value": 1,
    "lat": -12.498405,
    "lng": 130.964515
  },
  {
    "name": "Marrara",
    "value": 6,
    "lat": -12.3979277,
    "lng": 130.8790753
  },
  {
    "name": "Marrara Gardens",
    "value": 1,
    "lat": -12.4014358,
    "lng": 130.9043474
  },
  {
    "name": "Millner",
    "value": 1,
    "lat": -12.3908239,
    "lng": 130.8634702
  },
  {
    "name": "Mitchell Creek Green",
    "value": 1,
    "lat": -19.6481652,
    "lng": 134.1899847
  },
  {
    "name": "Mt Bundy",
    "value": 1,
    "lat": -21.754962740920124,
    "lng": 135.63570436650514
  },
  {
    "name": "Muirhead",
    "value": 1,
    "lat": -12.3582139,
    "lng": 130.8950256
  },
  {
    "name": "Northcrest",
    "value": 4,
    "lat": -12.440692899999998,
    "lng": 130.9297483479686
  },
  {
    "name": "Northcrest Berrimah",
    "value": 2,
    "lat": -12.4406929,
    "lng": 130.9297483
  },
  {
    "name": "Palmerston",
    "value": 4,
    "lat": -12.496316,
    "lng": 130.97966719913364
  },
  {
    "name": "Palmertson",
    "value": 1,
    "lat": -19.8516101,
    "lng": 133.2303375
  },
  {
    "name": "Parap",
    "value": 3,
    "lat": -12.4297422,
    "lng": 130.8488702
  },
  {
    "name": "RAAF",
    "value": 6,
    "lat": -14.5190289,
    "lng": 132.3801292
  },
  {
    "name": "Rapid Creek",
    "value": 2,
    "lat": -12.3808953,
    "lng": 130.8623385
  },
  {
    "name": "Remote",
    "value": 2,
    "lat": -12.4607076,
    "lng": 130.9276237
  },
  {
    "name": "Rosberry",
    "value": 1,
    "lat": -19.8516101,
    "lng": 133.2303375
  },
  {
    "name": "Roseberry",
    "value": 1,
    "lat": -12.5087632,
    "lng": 130.9903203
  },
  {
    "name": "Tindal",
    "value": 3,
    "lat": -14.4986496,
    "lng": 132.3969334
  },
  {
    "name": "Tiwi",
    "value": 13,
    "lat": -12.3586887,
    "lng": 130.881468
  },
  {
    "name": "Wagaman",
    "value": 1,
    "lat": -12.3796136,
    "lng": 130.8868932
  },
  {
    "name": "Wanguri",
    "value": 3,
    "lat": -12.3721897,
    "lng": 130.8869884
  },
  {
    "name": "Winellie",
    "value": 3,
    "lat": -12.4262769,
    "lng": 130.8936016
  },
  {
    "name": "Winnellie",
    "value": 9,
    "lat": -12.428889,
    "lng": 130.869722
  },
  {
    "name": "Wishart",
    "value": 1,
    "lat": -12.4575,
    "lng": 130.9341667
  },
  {
    "name": "Woolner",
    "value": 1,
    "lat": -12.437778,
    "lng": 130.8475
  },
  {
    "name": "Wulagi",
    "value": 2,
    "lat": -12.3845598,
    "lng": 130.8950847
  },
  {
    "name": "Yarrawonga",
    "value": 1,
    "lat": -12.471085,
    "lng": 130.990115
  },
  {
    "name": "Zuccoli",
    "value": 15,
    "lat": -12.5117584,
    "lng": 131.0033678
  },
  {
    "name": "Zucolli",
    "value": 14,
    "lat": -12.5119276,
    "lng": 131.0075467
  }
];
